import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import './i18n';
import App from './app/App';
import reportWebVitals from './reportWebVitals';
import './assets/fonts/fonts.css';

import { BrowserRouter } from 'react-router-dom';
import { getCurrentRegion } from './helpers/siteHelpers';
import { applyHubTheme, shouldUseHubTheme } from './theme/hubTheme';
import { PUBLIC_API_BASE_URL } from './config/api';
import { BUILD_INFO } from './config/buildInfo';
import { getUserToken } from './helpers/authHelpers';
import { installErrorReporter } from './services/errorReporter';

// System Health error reporter (spec §10). Installed before the first render so a crash while
// mounting is still reported. The region comes from the hostname, as everywhere else in the app.
installErrorReporter({
  app: 'ADMIN',
  endpoint: `${PUBLIC_API_BASE_URL}/client-errors`,
  getRegion: getCurrentRegion,
  getToken: async () => (await getUserToken()) ?? null,
  releaseTag: `${BUILD_INFO.commit}${process.env.NODE_ENV !== 'production' ? '-dev' : ''}`,
});

/*
  Decided before the first render, so the page never paints in one palette and then repaints in
  another. The region comes from the hostname, which is a real boundary between offices rather
  than something a viewer can pick.
*/
applyHubTheme(shouldUseHubTheme(getCurrentRegion(), window.location.search));

ReactDOM.render(
  <BrowserRouter>
    <App />
  </BrowserRouter>,
  document.getElementById('root')
);

reportWebVitals();
